module.exports = __webpack_public_path__ + "static/media/romanian_iar80.e1cbfd5f.png";